import { useState } from "react";
import { Plus } from "lucide-react";
import { today, useCan, useLoad } from "@/lib/api";
import { ErrorBox, PageHeading } from "@/components/common";
import AppointmentForm from "@/components/forms/AppointmentForm";
import AppointmentList from "@/components/AppointmentList";

const VIEWS = [["day", "Day"], ["tomorrow", "Tomorrow · reminders"], ["upcoming", "Upcoming"], ["overdue", "Overdue"], ["missed", "Missed"]];
const tomorrow = () => { const d = new Date(); d.setDate(d.getDate() + 1); return d.toLocaleDateString("en-CA"); };

export default function Appointments() {
  const can = useCan();
  const [view, setView] = useState("day");
  const [day, setDay] = useState(today());
  const [show, setShow] = useState(false);
  const ref = view === "day" ? day : view === "tomorrow" ? tomorrow() : today();
  const list = useLoad(`/appointments?view=${view === "tomorrow" ? "day" : view}&day=${ref}`, []);
  const counts = useLoad(`/appointments/summary?day=${today()}`, {});
  const refresh = () => { setShow(false); list.reload(); counts.reload(); };
  return (
    <div className="content">
      <PageHeading eyebrow="APPOINTMENTS / FOLLOW-UPS" title="No patient" accent="slips through." sub="Past appointments stay overdue until someone marks them attended, missed or rescheduled.">
        {can("appointments:write") && <button className="primary" onClick={() => setShow(true)} data-testid="add-appointment-button"><Plus size={18} /> Book appointment</button>}
      </PageHeading>
      <div className="toolbar">
        <div className="chips">
          {VIEWS.map(([v, l]) => <button key={v} className={view === v ? "chip active" : "chip"} onClick={() => setView(v)} data-testid={`appointments-view-${v}`}>{l}{!["day", "tomorrow"].includes(v) && counts.data[v] ? ` · ${counts.data[v]}` : ""}</button>)}
          {view === "day" && <input type="date" className="date-input" value={day} onChange={(e) => e.target.value && setDay(e.target.value)} data-testid="appointments-day-input" />}
        </div>
        <span className="result-count" data-testid="appointment-count">{list.data.length} appointments</span>
      </div>
      <ErrorBox error={list.error} testid="appointments-error" />
      <AppointmentList rows={list.data} onChanged={refresh} />
      {show && <AppointmentForm onClose={() => setShow(false)} onSaved={refresh} />}
    </div>
  );
}
